import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";
import { requireAuth, requireGuest } from "./auth-guard";
import { hasPermission } from "../utils/permission";

import DashboardPage from "../pages/Dashboard/DashboardPage.vue";
import CreateProductsPage from "../pages/Products/CreateProductsPage.vue";
import ProductsListPage from "../pages/Products/ProductsListPage.vue";
import EditProductsPage from "../pages/Products/EditProductsPage.vue";
import PrintBarcodePage from "../pages/Products/PrintBarcodePage.vue";
import ProductDetailsPage from "../pages/Products/ProductDetailsPage.vue";
import CreateAdjustmentsPage from "../pages/Adjustments/CreateAdjustmentsPage.vue";
import AdjustmentListPage from "../pages/Adjustments/AdjustmentListPage.vue";
import EditAdjustmentPage from "../pages/Adjustments/EditAdjustmentPage.vue";
import CreateTransferPage from "../pages/Transfer/CreateTransferPage.vue";
import TransferListPage from "../pages/Transfer/TransferListPage.vue";
import EditTransferPage from "../pages/Transfer/EditTransferPage.vue";
import CreateExpensesPage from "../pages/Expenses/CreateExpensesPage.vue";
import ExpensesListPage from "../pages/Expenses/ExpensesListPage.vue";
import EditExpensesPage from "../pages/Expenses/EditExpensesPage.vue";
import ExpenseCategoryPage from "../pages/Expenses/ExpenseCategoryPage.vue";
import CreateIncomePage from "../pages/Finance/CreateIncomePage.vue";
import IncomeListPage from "../pages/Finance/IncomeListPage.vue";
import EditIncomePage from "../pages/Finance/EditIncomePage.vue";
import IncomeCategoryPage from "../pages/Finance/IncomeCategoryPage.vue";
import CreateQuotationPage from "../pages/Quotations/CreateQuotationPage.vue";
import QuotationListPage from "../pages/Quotations/QuotationListPage.vue";
import EditQuotationPage from "../pages/Quotations/EditQuotationPage.vue";
import CreatePurchasePage from "../pages/Purchases/CreatePurchasePage.vue";
import PurchaseListPage from "../pages/Purchases/PurchaseListPage.vue";
import EditPurchasePage from "../pages/Purchases/EditPurchasePage.vue";
import CreateSalesPage from "../pages/Sales/CreateSalesPage.vue";
import SalesListPage from "../pages/Sales/SalesListPage.vue";
import EditSalesPage from "../pages/Sales/EditSalesPage.vue";
import PosSalesListPage from "../pages/Sales/PosSalesListPage.vue";
import PosPage from "../pages/Sales/PosPage.vue";
import PosCustomerDisplayPage from "../pages/Sales/PosCustomerDisplayPage.vue";
import PosQueuePage from "../pages/Sales/PosQueuePage.vue";
import PosPickupDisplayPage from "../pages/Sales/PosPickupDisplayPage.vue";
import ShipmentPage from "../pages/Sales/ShipmentPage.vue";
import CreateSalesReturnPage from "../pages/SalesReturn/CreateSalesReturnPage.vue";
import SalesReturnListPage from "../pages/SalesReturn/SalesReturnListPage.vue";
import EditSalesReturnPage from "../pages/SalesReturn/EditSalesReturnPage.vue";
import CreatePurchaseReturnPage from "../pages/PurchaseReturn/CreatePurchaseReturnPage.vue";
import PurchaseReturnListPage from "../pages/PurchaseReturn/PurchaseReturnListPage.vue";
import EditPurchaseReturnPage from "../pages/PurchaseReturn/EditPurchaseReturnPage.vue";
import CustomerListPage from "../pages/People/CustomerListPage.vue";
import SupplierListPage from "../pages/People/SupplierListPage.vue";
import UserListPage from "../pages/People/UserListPage.vue";
import SystemSettingsPage from "../pages/Settings/SystemSettingsPage.vue";
import MyProfilePage from "../pages/Settings/MyProfilePage.vue";
import GroupPermissionPage from "../pages/Settings/GroupPermissionPage.vue";
import CreateGroupPermissionPage from "../pages/Settings/CreateGroupPermissionPage.vue";
import EditGroupPermissionPage from "../pages/Settings/EditGroupPermissionPage.vue";
import WarehousePage from "../pages/Settings/WarehousePage.vue";
import CategoryPage from "../pages/Settings/CategoryPage.vue";
import BrandListPage from "../pages/Settings/BrandListPage.vue";
import CurrncyListPage from "../pages/Settings/CurrncyListPage.vue";
import UnitListPage from "../pages/Settings/UnitListPage.vue";
import SizeListPage from "../pages/Settings/SizeListPage.vue";
import SugarListPage from "../pages/Settings/SugarListPage.vue";
import CouponListPage from "../pages/Settings/CouponListPage.vue";
import MembershipCardPage from "../pages/Settings/MembershipCardPage.vue";
import PromotionListPage from "../pages/Settings/PromotionListPage.vue";
import BackupPage from "../pages/Settings/BackupPage.vue";
import PurchaseReportPage from "../pages/Reports/PurchaseReportPage.vue";
import PurchasePaymentReportPage from "../pages/Reports/PurchasePaymentReportPage.vue";
import PurchaseReturnReportPage from "../pages/Reports/PurchaseReturnReportPage.vue";
import SalesReportPage from "../pages/Reports/SalesReportPage.vue";
import PosSalesReportPage from "../pages/Reports/PosSalesReportPage.vue";
import SalesPaymentReportPage from "../pages/Reports/SalesPaymentReportPage.vue";
import PosSalesPaymentReportPage from "../pages/Reports/PosSalesPaymentReportPage.vue";
import SalesReturnReportPage from "../pages/Reports/SalesReturnReportPage.vue";
import ProductQuantityAlertPage from "../pages/Reports/ProductQuantityAlertPage.vue";
import ProfitLossPage from "../pages/Reports/ProfitLossPage.vue";
import ProductReportPage from "../pages/Reports/ProductReportPage.vue";
import StockReportPage from "../pages/Reports/StockReportPage.vue";
import StockReportDetailsPage from "../pages/Reports/StockReportDetailsPage.vue";
import WarehouseReportPage from "../pages/Reports/WarehouseReportPage.vue";
import CustomerReportPage from "../pages/Reports/CustomerReportPage.vue";
import SupplierReportPage from "../pages/Reports/SupplierReportPage.vue";
import UserReportPage from "../pages/Reports/UserReportPage.vue";
import RegisterHistoryPage from "../pages/Reports/RegisterHistoryPage.vue";
import LandingPage from "../pages/BestElectronicsShop/LandingPage.vue";
import ShopRightSidebarPage from "../pages/BestElectronicsShop/ShopRightSidebarPage.vue";
import ShopLeftSidebarPage from "../pages/BestElectronicsShop/ShopLeftSidebarPage.vue";
import ShopGridPage from "../pages/BestElectronicsShop/ShopGridPage.vue";
import ShopDetailsPage from "../pages/BestElectronicsShop/ShopDetailsPage.vue";
import CartPage from "../pages/BestElectronicsShop/CartPage.vue";
import WishlistPage from "../pages/BestElectronicsShop/WishlistPage.vue";
import CheckoutPage from "../pages/BestElectronicsShop/CheckoutPage.vue";
import LoginPage from "../pages/BestElectronicsShop/LoginPage.vue";
import TermsConditionsPage from "../pages/BestElectronicsShop/TermsConditionsPage.vue";
import OfferPage from "../pages/BestElectronicsShop/OfferPage.vue";
import FaqPage from "../pages/BestElectronicsShop/FaqPage.vue";
import ContactPage from "../pages/BestElectronicsShop/ContactPage.vue";

const routes: Array<RouteRecordRaw> = [
  // Public routes (no authentication required)
  { path: "/landing-page", name: "LandingPage", component: LandingPage },
  { path: "/shop-right-sidebar", name: "ShopRightSidebarPage", component: ShopRightSidebarPage },
  { path: "/shop-left-sidebar", name: "ShopLeftSidebarPage", component: ShopLeftSidebarPage },
  { path: "/shop-grid", name: "ShopGridPage", component: ShopGridPage },
  { path: "/shop-details", name: "ShopDetailsPage", component: ShopDetailsPage },
  { path: "/cart", name: "CartPage", component: CartPage },
  { path: "/wishlist", name: "WishlistPage", component: WishlistPage },
  { path: "/checkout", name: "CheckoutPage", component: CheckoutPage },
  { path: "/terms-conditions", name: "TermsConditionsPage", component: TermsConditionsPage },
  { path: "/offers", name: "OfferPage", component: OfferPage },
  { path: "/faq", name: "FaqPage", component: FaqPage },
  { path: "/contact", name: "ContactPage", component: ContactPage },
  
  // Guest-only routes (redirect to dashboard if authenticated)
  { 
    path: "/login", 
    name: "LoginPage", 
    component: LoginPage,
    beforeEnter: requireGuest
  },

  // Protected routes (authentication required)
  {
    path: "/",
    name: "DashboardPage",
    component: DashboardPage,
    beforeEnter: requireAuth,
  },
  {
    path: "/create-product",
    name: "CreateProductsPage",
    component: CreateProductsPage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_create' }
  },
  {
    path: "/product-list",
    name: "ProductsListPage",
    component: ProductsListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_index' }
  },
  {
    path: "/edit-product",
    name: "EditProductsPage",
    component: EditProductsPage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_update' }
  },
  {
    path: "/product-details",
    name: "ProductDetailsPage",
    component: ProductDetailsPage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_index' }
  },
  {
    path: "/print-barcode",
    name: "PrintBarcodePage",
    component: PrintBarcodePage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_barcode' }
  },
  {
    path: "/create-adjustment",
    name: "CreateAdjustmentsPage",
    component: CreateAdjustmentsPage,
    beforeEnter: requireAuth,
    meta: { permission: 'adjustment_create' }
  },
  {
    path: "/adjustment-list",
    name: "AdjustmentListPage",
    component: AdjustmentListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'adjustment_index' }
  },
  {
    path: "/edit-adjustment/:id",
    name: "EditAdjustmentPage",
    component: EditAdjustmentPage,
    beforeEnter: requireAuth,
    meta: { permission: 'adjustment_update' }
  },
  {
    path: "/create-transfer",
    name: "CreateTransferPage",
    component: CreateTransferPage,
    beforeEnter: requireAuth,
    meta: { permission: 'movement_create' }
  },
  {
    path: "/transfer-list",
    name: "TransferListPage",
    component: TransferListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'movement_index' }
  },
  {
    path: "/edit-transfer/:id",
    name: "EditTransferPage",
    component: EditTransferPage,
    beforeEnter: requireAuth,
    meta: { permission: 'movement_update' }
  },
  {
    path: "/create-expense",
    name: "CreateExpensesPage",
    component: CreateExpensesPage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_create' }
  },
  {
    path: "/expense-list",
    name: "ExpensesListPage",
    component: ExpensesListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_index' }
  },
  {
    path: "/edit-expense/:id",
    name: "EditExpensesPage",
    component: EditExpensesPage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_update' }
  },
  {
    path: "/expense-category",
    name: "ExpenseCategoryPage",
    component: ExpenseCategoryPage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_category_index' }
  },
  {
    path: "/create-income",
    name: "CreateIncomePage",
    component: CreateIncomePage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_create' }
  },
  {
    path: "/income-list",
    name: "IncomeListPage",
    component: IncomeListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_index' }
  },
  {
    path: "/edit-income/:id",
    name: "EditIncomePage",
    component: EditIncomePage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_update' }
  },
  {
    path: "/income-category",
    name: "IncomeCategoryPage",
    component: IncomeCategoryPage,
    beforeEnter: requireAuth,
    meta: { permission: 'expense_category_index' }
  },
  {
    path: "/create-quotation",
    name: "CreateQuotationPage",
    component: CreateQuotationPage,
    beforeEnter: requireAuth,
    meta: { permission: 'quote_create' }
  },
  {
    path: "/quotation-list",
    name: "QuotationListPage",
    component: QuotationListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'quote_index' }
  },
  {
    path: "/edit-quotation/:id",
    name: "EditQuotationPage",
    component: EditQuotationPage,
    beforeEnter: requireAuth,
    meta: { permission: 'quote_update' }
  },
  {
    path: "/create-purchase",
    name: "CreatePurchasePage",
    component: CreatePurchasePage,
    beforeEnter: requireAuth,
    meta: { permission: 'purchase_create' }
  },
  {
    path: "/purchase-list",
    name: "PurchaseListPage",
    component: PurchaseListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'purchase_index' }
  },
  {
    path: "/edit-purchase/:id",
    name: "EditPurchasePage",
    component: EditPurchasePage,
    beforeEnter: requireAuth,
    meta: { permission: 'purchase_update' }
  },
  {
    path: "/create-sales",
    name: "CreateSalesPage",
    component: CreateSalesPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_create' }
  },
  {
    path: "/sales-list",
    name: "SalesListPage",
    component: SalesListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_index' }
  },
  {
    path: "/edit-sales",
    name: "EditSalesPage",
    component: EditSalesPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_update' }
  },
  {
    path: "/edit-sales/:id",
    name: "EditSalesPageWithId",
    component: EditSalesPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_update' }
  },
  {
    path: "/pos-sales-list",
    name: "PosSalesListPage",
    component: PosSalesListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'pos_sale_index' }
  },
  {
    path: "/pos/customer-display",
    name: "PosCustomerDisplayPage",
    component: PosCustomerDisplayPage,
    beforeEnter: requireAuth,
  },
  {
    path: "/pos/queue",
    name: "PosQueuePage",
    component: PosQueuePage,
    beforeEnter: requireAuth,
    meta: { permission: 'pos_sale_index' }
  },
  {
    path: "/pos/pickup-display",
    name: "PosPickupDisplayPage",
    component: PosPickupDisplayPage,
    beforeEnter: requireAuth,
  },
  {
    path: "/pos/:id?",
    name: "PosPage",
    component: PosPage,
    beforeEnter: requireAuth,
    meta: { permission: 'pos_sale_index' }
  },
  {
    path: "/shipment-list",
    name: "ShipmentPage",
    component: ShipmentPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_index' }
  },
  {
    path: "/create-sales-return",
    name: "CreateSalesReturnPage",
    component: CreateSalesReturnPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_create' }
  },
  {
    path: "/sales-return-list",
    name: "SalesReturnListPage",
    component: SalesReturnListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_index' }
  },
  {
    path: "/edit-sales-return/:id",
    name: "EditSalesReturnPage",
    component: EditSalesReturnPage,
    beforeEnter: requireAuth,
    meta: { permission: 'sale_update' }
  },
  {
    path: "/create-purchase-return",
    name: "CreatePurchaseReturnPage",
    component: CreatePurchaseReturnPage,
    beforeEnter: requireAuth,
    meta: { permission: 'purchase_create' }
  },
  {
    path: "/purchase-return-list",
    name: "PurchaseReturnListPage",
    component: PurchaseReturnListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'purchase_index' }
  },
  {
    path: "/edit-purchase-return",
    name: "EditPurchaseReturnPage",
    component: EditPurchaseReturnPage,
    beforeEnter: requireAuth,
    meta: { permission: 'purchase_update' }
  },
  {
    path: "/customer-list",
    name: "CustomerListPage",
    component: CustomerListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'customer_index' }
  },
  {
    path: "/supplier-list",
    name: "SupplierListPage",
    component: SupplierListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'supplier_index' }
  },
  {
    path: "/user-list",
    name: "UserListPage",
    component: UserListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'role_index' }
  },
  {
    path: "/system-settings",
    name: "SystemSettingsPage",
    component: SystemSettingsPage,
    beforeEnter: requireAuth,
    meta: { permission: 'setting_index' }
  },
  {
    path: "/my-profile",
    name: "MyProfilePage",
    component: MyProfilePage,
    beforeEnter: requireAuth,
  },
  {
    path: "/group-permission",
    name: "GroupPermissionPage",
    component: GroupPermissionPage,
    beforeEnter: requireAuth,
    meta: { permission: 'role_permission' }
  },
  {
    path: "/create-group-permission",
    name: "CreateGroupPermissionPage",
    component: CreateGroupPermissionPage,
    beforeEnter: requireAuth,
    meta: { permission: 'role_permission' }
  },
  {
    path: "/edit-group-permission/:id",
    name: "EditGroupPermissionPage",
    component: EditGroupPermissionPage,
    beforeEnter: requireAuth,
    meta: { permission: 'role_permission' }
  },
  {
    path: "/warehouse-list",
    name: "WarehousePage",
    component: WarehousePage,
    beforeEnter: requireAuth,
    meta: { permission: 'warehouse_index' }
  },
  {
    path: "/category-list",
    name: "CategoryPage",
    component: CategoryPage,
    beforeEnter: requireAuth,
    meta: { permission: 'category_index' }
  },
  {
    path: "/brand-list",
    name: "BrandListPage",
    component: BrandListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'brand_index' }
  },
  {
    path: "/currency-list",
    name: "CurrncyListPage",
    component: CurrncyListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'currency_index' }
  },
  {
    path: "/unit-list",
    name: "UnitListPage",
    component: UnitListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'unit_index' }
  },
  {
    path: "/size-list",
    name: "SizeListPage",
    component: SizeListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_index' }
  },
  {
    path: "/sugar-list",
    name: "SugarListPage",
    component: SugarListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'product_index' }
  },
  {
    path: "/backup",
    name: "BackupPage",
    component: BackupPage,
    beforeEnter: requireAuth,
    meta: { permission: 'setting_index' },
  },
  {
    path: "/coupon-list",
    name: "CouponListPage",
    component: CouponListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'coupon_index' },
  },
  {
    path: "/membership-cards",
    name: "MembershipCardPage",
    component: MembershipCardPage,
    beforeEnter: requireAuth,
    meta: { permission: 'membership_card_index' },
  },
  {
    path: "/promotion-list",
    name: "PromotionListPage",
    component: PromotionListPage,
    beforeEnter: requireAuth,
    meta: { permission: 'promotion_index' },
  },
  {
    path: "/purchase-report",
    name: "PurchaseReportPage",
    component: PurchaseReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_purchase' }
  },
  {
    path: "/purchase-payment-report",
    name: "PurchasePaymentReportPage",
    component: PurchasePaymentReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_payment' }
  },
  {
    path: "/purchase-return-report",
    name: "PurchaseReturnReportPage",
    component: PurchaseReturnReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_purchase' }
  },
  {
    path: "/sales-report",
    name: "SalesReportPage",
    component: SalesReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_sale' }
  },
  {
    path: "/pos-sales-report",
    name: "PosSalesReportPage",
    component: PosSalesReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_sale' }
  },
  {
    path: "/sales-payment-report",
    name: "SalesPaymentReportPage",
    component: SalesPaymentReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_sale' }
  },
  {
    path: "/pos-sales-payment-report",
    name: "PosSalesPaymentReportPage",
    component: PosSalesPaymentReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_sale' }
  },
  {
    path: "/sales-return-report",
    name: "SalesReturnReportPage",
    component: SalesReturnReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_sale' }
  },
  {
    path: "/product-quantity-alert",
    name: "ProductQuantityAlertPage",
    component: ProductQuantityAlertPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_quantity_alert' }
  },
  {
    path: "/profit-loss",
    name: "ProfitLossPage",
    component: ProfitLossPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_pnl' }
  },
  {
    path: "/product-report",
    name: "ProductReportPage",
    component: ProductReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_product' }
  },
  {
    path: "/stock-report",
    name: "StockReportPage",
    component: StockReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_stock' }
  },
  {
    path: "/stock-report-details",
    name: "StockReportDetailsPage",
    component: StockReportDetailsPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_stock' }
  },
  {
    path: "/warehouse-report",
    name: "WarehouseReportPage",
    component: WarehouseReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_warehouse' }
  },
  {
    path: "/customer-report",
    name: "CustomerReportPage",
    component: CustomerReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_customer' }
  },
  {
    path: "/supplier-report",
    name: "SupplierReportPage",
    component: SupplierReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_supplier' }
  },
  {
    path: "/user-report",
    name: "UserReportPage",
    component: UserReportPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_user' }
  },
  {
    path: "/register-history",
    name: "RegisterHistoryPage",
    component: RegisterHistoryPage,
    beforeEnter: requireAuth,
    meta: { permission: 'report_sale' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

// Global navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  
  // Check if the route requires authentication
  const requiresAuth = to.matched.some(record => {
    // Check if any route in the matched chain has beforeEnter guard
    return record.meta?.requiresAuth || record.beforeEnter === requireAuth;
  });
  
  // If route requires authentication and user is not authenticated
  if (requiresAuth && (!token || !user)) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    // Check for specific permission
    if (to.meta.permission) {
      if (!hasPermission(to.meta.permission as string)) {
        // User doesn't have permission, redirect to dashboard
        return next('/');
      }
    }
    next();
  }
});

export default router;
